import { useFormContext } from "react-hook-form";

import KogCheckBoxControlled from "@/main/components/shared/checkbox/checkBoxControlled";
import { GeneralVariableType, useDynamicFiltersExport } from "./dynamicFiltersExport";
import { IFormFiltersDynamicExport } from "../modalExportDynamicReport";

interface IVariableTypeBooleanProps extends GeneralVariableType {}
function VariableTypeBoolean({ filter }: IVariableTypeBooleanProps) {
	const { findFieldIndexByGuidDynamicReportVariable } = useDynamicFiltersExport();

	const { control } = useFormContext<IFormFiltersDynamicExport>();

	const indexField = findFieldIndexByGuidDynamicReportVariable(filter.guidDynamicReportVariable);

	return (
		<>
			<KogCheckBoxControlled
				nameCustom={`filtersDinamics.${indexField}.value`}
				control={control}
				required={filter.responseServer.mandatory}
				label={filter.responseServer.filterName}
			/>
		</>
	);
}

export default VariableTypeBoolean;
